export const joinWords = (...wordsToJoin) => {
    return wordsToJoin.join(" ").replace(/\s{2,}/g, " ")
}

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }